document.addEventListener('DOMContentLoaded', function() {
    const productDetails = document.getElementById('product-details');
    const leftColumn = document.getElementById('product-left-column');
    const originalParent = productDetails.parentNode;
    let detailsMovedToLeft = false;

    function adjustLayout() {
        if (window.innerWidth >= 769) {
            if (!detailsMovedToLeft) {
                leftColumn.appendChild(productDetails);
                detailsMovedToLeft = true;
            }
        } else {
            if (detailsMovedToLeft) {
                originalParent.appendChild(productDetails);
                detailsMovedToLeft = false;
            }
        }
    }

    // Run on page load
    adjustLayout();

    // Debounced function for window resize
    const debouncedAdjustLayout = theme.utils.debounce(250, adjustLayout);

    // Run on window resize with debounce
    window.addEventListener('resize', debouncedAdjustLayout);
});